import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const RadioButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  width: fit-content;
  position: absolute;
  right: -15px;
  top: 6px;
   pointer-events: none;
`;

const RadioButtonLabel = styled.label`
 pointer-events: none;
  display: flex;
  align-items: center;
  margin-right: 22px;
  //   background-color: ${(props) =>
    props.isChecked ? "#F0FBFF" : "transparent"};
  gap: 12px;
  flex: 1 0 30%;
  cursor: pointer;
//   width: 264px;
  height: 44px;
  padding: 0px 16px;
  border-radius: 8px;
  &:last-child {
    flex: unset;
  }
`;

const RadioInput = styled.input`
 pointer-events: none;
  width: 20px;
  height: 20px;
  appearance: none;
  border: 3px solid #fff;
  border-radius: 50%;
  outline: 1px solid #B4B5B8;
  cursor: pointer;
  margin: 0px !important;
  padding: 0px;
  &:checked,
  &:focus {
    background-color: #00baff !important;
    outline: 1px solid #00baff !important;
    font-size: 16px;
    outline-offset: unset !important;
  }
`;

const RadioButton = ({ isChecked }) => {

  return (
    <RadioButtonContainer>
      <RadioButtonLabel isChecked={isChecked}>
        <RadioInput
          type="radio"
          id={`radio_check`}
          name="radio_group"
          checked={isChecked}
        />
      </RadioButtonLabel>
    </RadioButtonContainer>
  );
};

RadioButton.propTypes = {
  isChecked: PropTypes.bool,
};

export default RadioButton;
